import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classes from './Subscription.module.scss';
import Badge from '@shared/Badge/Badge';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { childUserSelector } from '@models/user/selectors';
import { myMTSSelector, isChildOwnerSelector, ownerSelector, netariffSelector, isProlongationAvailableSelector, anniversarySelector, subscriptionSelector, isProlongationAvailableSelectorAnniversary, } from '@models/subscription/selectors';
import Services from './Services/Services';
import Children from './Children/Children';
import { useWindowSize } from '@hooks/useWindowSize';
import TariffText from './TariffText/TariffText';
import { childAddAvailabilitySelector, paymentStatusesSelector, subscriptionStatusSelector, subscriptionStatusesSelector, } from '@models/subscription/selectors';
import Settings from './Settings/Settings';
import { getCounterProps, getSubscriptionBadgeProps } from '@configs/subscription';
import { getSubscriptionStatuses } from '@utils/getSubscriptionStatuses';
import TariffAction from './TariffAction/TariffAction';
import { isPaymentConnectSelector } from '@models/subscription/selectors';
import { useTypedDispatch } from '@hooks/useTypedDispatch';
import ProductLogo from '@shared/ProductLogo/ProductLogo';
import PromocodeButton from './PromocodeButton/PromocodeButton';
import { useNavigate } from 'react-router';
import { Page } from '@const';
import { triggerMetricsEvent } from '@metrics';
const Subscription = ({ className }) => {
    const isMyMTS = useSelector(myMTSSelector);
    const subscription = useSelector(subscriptionSelector);
    const isChildAuth = useSelector(childUserSelector);
    const version = isChildAuth ? 'child' : 'parent';
    const subscriptionStatus = useSelector(subscriptionStatusSelector);
    const { parent: { adding: isSubscriptionAdding }, } = useSelector(subscriptionStatusesSelector);
    const { remainingDays } = subscription;
    const { isRemainingPaid, isTrialLeft } = useSelector(paymentStatusesSelector);
    const { isSubscriptionSuspended, isSubscriptionProcess } = getSubscriptionStatuses(subscriptionStatus);
    const { isMobile, isDesktop } = useWindowSize();
    const isAddAvailable = useSelector(childAddAvailabilitySelector);
    const isProlongationAvailable = useSelector(isProlongationAvailableSelector);
    const isProlongationAnniversaryAvailable = useSelector(isProlongationAvailableSelectorAnniversary);
    const isAnniversary = useSelector(anniversarySelector);
    const showCounterBlock = isTrialLeft || isRemainingPaid;
    const showActions = isProlongationAnniversaryAvailable && (showCounterBlock || isSubscriptionSuspended || isProlongationAvailable);
    const isConnection = useSelector(isPaymentConnectSelector);
    const isChildOwner = useSelector(isChildOwnerSelector);
    const isAuthUserOwner = useSelector(ownerSelector);
    const isNetariff = useSelector(netariffSelector);
    const navigate = useNavigate();
    const { subscriptionModel: { changePaymentTool }, } = useTypedDispatch();
    const containerClasses = classNames(classes.container, className, {
        [classes.withAction]: showActions,
        [classes.child]: version === 'child',
        [classes.withChildManagement]: isChildOwner,
    });
    const childrenClasses = classNames(classes.children, {
        [classes.withAdd]: isAddAvailable,
    });
    const badgeProps = subscriptionStatus ? getSubscriptionBadgeProps(subscriptionStatus) : null;
    const variant = badgeProps?.variant === 'warning' ? 'negative' : badgeProps?.variant;
    const tariff = (_jsx("div", { className: classes.tariff, children: _jsx(TariffText, {}) }));
    const settings = (_jsx("div", { className: classes.settings, children: _jsx(Settings, {}) }));
    const handleRenew = () => {
        navigate(Page.CreateSubscription);
    };
    const handlePay = () => {
        changePaymentTool({});
    };
    const handleProlongation = () => {
        triggerMetricsEvent({ element: 'continueSubscribeClick' });
        navigate(Page.UpdateSubscription);
    };
    const isPromocodeAvailable = !isChildOwner && !isNetariff && !isAnniversary;
    const { buttonText } = getCounterProps(isTrialLeft);
    const counter = _jsx(TariffAction, { buttonText: buttonText, onClick: handleRenew, hideButton: true, isLoading: isConnection });
    const payment = _jsx(TariffAction, { buttonText: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C", isLoading: isConnection, onClick: handlePay, hideButton: true, isError: true });
    const prolongation = (_jsx(TariffAction, { buttonText: "\u041F\u0440\u043E\u0434\u043B\u0438\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0443", hideButton: true, isLoading: isConnection, onClick: handleProlongation }));
    const promocodeButton = isPromocodeAvailable && _jsx(PromocodeButton, { disabled: isSubscriptionAdding, className: classes.promocodeButton });
    const title = (_jsxs("div", { className: classes.bageWrap, children: [isMyMTS && _jsx(ProductLogo, { className: classes.logo }), badgeProps && variant && _jsx(Badge, { variant: variant, text: badgeProps.text, withIcon: false })] }));
    const actionContent = isProlongationAnniversaryAvailable || remainingDays === 0 ? (_jsx("div", { className: classes.action, children: prolongation })) : (_jsx("div", { className: classes.action, children: isProlongationAvailable ? prolongation : showCounterBlock ? counter : payment }));
    const servicesContent = (_jsx("div", { className: classes.services, children: _jsx(Services, {}) }));
    const showTariffText = !showActions && (!isSubscriptionProcess || isAnniversary);
    const contentMap = {
        withoutManagement: (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.header, children: title }), _jsx("div", { className: classes.serviceWrap, children: servicesContent })] })),
        withManagement: (_jsxs(_Fragment, { children: [_jsxs("div", { className: classes.header, children: [_jsxs("div", { className: classes.tariffWrap, children: [_jsxs("div", { className: classes.titleWrap, children: [title, settings] }), showTariffText && tariff, isMobile && showActions && actionContent] }), !isChildAuth && _jsx(Children, { isAddAvailable: isAddAvailable, className: childrenClasses }), !isMobile && showActions && actionContent] }), _jsx("div", { className: classes.serviceWrap, children: servicesContent })] })),
    };
    const managementConfigName = isAuthUserOwner ? 'withManagement' : 'withoutManagement';
    return _jsx("section", { className: containerClasses, children: contentMap[managementConfigName] });
};
export default Subscription;
